import { render, staticRenderFns } from "./enderecoModal.vue?vue&type=template&id=74947aca&"
import script from "./enderecoModal.vue?vue&type=script&lang=js&"
export * from "./enderecoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports